import { Button, Stack, useTheme } from "@mui/material";
import { Bell } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { reminderRowAnchorId } from "web_myplann/NotificationCenter/Utils/reminderScrollParam";
import { ReminderEmptyState } from "web_myplann/Reminders/Components/ReminderEmptyState";
import { ReminderListRow } from "web_myplann/Reminders/Components/ReminderListRow";
import { ReminderListRowSkeleton } from "web_myplann/Reminders/Components/ReminderListRowSkeleton";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { DataCard } from "web_myplann/Shared/Components/DataCard";

type Props = {
	reminders: Reminder[];
	isLoading: boolean;
	highlightedId: string | null;
	onAdd: () => void;
	onTap: (reminder: Reminder) => void;
	onRemove: (reminder: Reminder) => void;
};

export const RemindersCardList = ({
	reminders,
	isLoading,
	highlightedId,
	onAdd,
	onTap,
	onRemove,
}: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<DataCard
			label={t(Resources.Reminders.Section.title)}
			icon={<Bell size={16} color={theme.palette.purple.main} />}
			noDivider
		>
			{isLoading ? (
				<Stack gap={1.6}>
					<ReminderListRowSkeleton />
					<ReminderListRowSkeleton />
				</Stack>
			) : reminders.length === 0 ? (
				<ReminderEmptyState onAdd={onAdd} />
			) : (
				<Stack gap={1.6}>
					{reminders.map((reminder) => (
						<ReminderListRow
							key={reminder.id}
							id={reminderRowAnchorId(reminder.id)}
							reminder={reminder}
							highlighted={reminder.id === highlightedId}
							onTap={() => onTap(reminder)}
							onRemove={() => onRemove(reminder)}
						/>
					))}
					<Button onClick={onAdd}>
						{t(Resources.Reminders.Section.addButton)}
					</Button>
				</Stack>
			)}
		</DataCard>
	);
};
